export default __webpack_public_path__ + "static/media/no_house_photo.24225519.png";